import { render } from "./RecommendationModal.vue?vue&type=template&id=66fb4000&scoped=true"
import script from "./RecommendationModal.vue?vue&type=script&lang=js"
export * from "./RecommendationModal.vue?vue&type=script&lang=js"

import "./RecommendationModal.vue?vue&type=style&index=0&id=66fb4000&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fb4000"]])

export default __exports__